import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import { TestimonialsSlider } from '../../../components/common/testimonials.slider';
import './testimonials.less';

const testimonials = [
  {
    title: 'Vše funguje rychle a efektivně',
    subtitle: 'Vše funguje rychle a efektivně, příjemné jednání, za mě naprostá spokojenost.',
    name: 'Aura Sdružení',
    position: 's.r.o',
  },
  {
    title: 'Rychlá nabídka a vyřízení s minimálním papírováním. Doporučuji...',
    name: 'ELEXO PROJEKT',
    position: 's.r.o.',
  },
  {
    title: 'Naprosto perfektní rychlé jednání. Dlouhodobá spokojenost.',
    name: 'Lucie Brabcová',
  },
  {
    title: 'Velice dobrá komunikace, rychlost, profesionální klientský přívětivý přístup.',
    name: 'ORFIN Industry',
    position: 's.r.o.',
  },
  {
    title: 'Dobrý den, mé hodnocení ke společnosti Lidya je hodně kladné. Se společností jsem rád na trhu a především si vážím pana Němečka, který je perfektní.',
    name: 'Michal Brožek',
  },
  {
    title: 'Musím říct opravdu velmi rychlé a kladné vyřízení žádosti za mě velká spokojenost.',
    name: 'Marcel Durec',
  },
  {
    title: 'Lidský a přívětivý přístup, rychlá komunikace. Rozhodně doporučuji ke spolupráci.',
    name: 'Daniel Blažek',
  },

];

const Testimonials = () => (
  <div className="o-testimonials">
    <div className="m-globalContentContainer m-testimonials__container">
      <div className="m-testimonials__imageContainer">
        <StaticImage
          src="../../images/uvery/icon_quotes.svg"
          alt="quotes image"
          title="quotes"
          className="m-testimonials__image"
        />
      </div>
      <TestimonialsSlider testimonials={testimonials} />
    </div>
  </div>
);

Testimonials.propTypes = {};

export default Testimonials;
